<div class="plug">
  <app-texts
             [texts]="[
          {text: ['Dear Ladies & Gentlemens', 'Dear Ladies & Gentlemens'], fontFamily: 'pd', fontStyle: 'italic', transfer: true},
          {text: [' the mobile version is coming soon ', ' the mobile version is coming soon '], transfer: true},
          {text: [' for now, please use a desktop version', ' for now, please use a desktop version'], },
        ]"
  />
</div>
<div class="content-cite" [class]="themeService.getTheme()">
  <app-header/>
  <app-menu/>
  <router-outlet/>
  <app-toast-notification/>
</div>
<div class="footer" [style]="'background: ' + footerService.getFooterColor()">
<!--  <app-main-destinations/>-->
  <app-footer *ngIf="showFooter"/>
</div>
<div class="fc-loading-container"
     [class.hidden]="!loading.getLoading()"
     [class.visible]="loading.getLoading()">
  <app-fc-loading />
</div>


